import { useApiClient, useEntityMetadata, useNavigation } from '@msdk/common'
import { EntityModel, StringValue, TenantPath, UserPath } from '@msdk/definitions'
import { useComponentModal } from '@msdk/forms'
import { DataRetentionDialog } from 'components/DataRetentionDialog/DataRetentionDialog'
import { useEffect, useState } from 'react'

export function useDataRetentionConfirmed() {
  const [result, setResult] = useState<boolean | undefined>(undefined)
  const client = useApiClient()
  const dialogModal = useComponentModal()
  const navigation = useNavigation()
  const entityModel = useEntityMetadata('DPR_CONFIGURATION') as EntityModel
  const tenant = new TenantPath()
  const isDPREnabled = tenant.IsMicroServiceEnabled('DPR')
  const isPAMEnabled = tenant.IsMicroServiceEnabled('PAM')
  const userPath = new UserPath()
  const isDPOLogged = userPath.HasRole('app.dpo')
  const isAdminLogged = userPath.HasRole('app.admin')
  const UiConfigModel = useEntityMetadata('UI_CONFIGURATION')
  useEffect(() => {
    const fetchdata = async () => {
      // eslint-disable-next-line @typescript-eslint/no-shadow
      if (!isDPREnabled || (!isDPOLogged && !isAdminLogged) || (isDPREnabled && !entityModel)) {
        setResult(true)
      } else {
        const entityOperation = await client.entity.getSingleton('DPR', '', entityModel)
        let isDataRetentionConfirmed = false
        if (entityOperation && entityOperation.entities && entityOperation.entities.length > 0) {
          const entity = entityOperation?.entities[0]
          isDataRetentionConfirmed = entity?.fields['DPR_CONFIGURATION_CONFIRMATION']?.value === '1'
          if (isDataRetentionConfirmed && isPAMEnabled) {
            isDataRetentionConfirmed = entity?.fields['DPR_CONFIGURATION_CONFIRMATION_PAM']?.value === '1'
          }
        }
        setResult(isDataRetentionConfirmed)
      }
    }
    fetchdata().catch(console.error)
  }, [])

  const onClose = async () => {
    const resultUiConfig = await client.entity.getSingleton('CMPS', '', UiConfigModel as EntityModel)
    const entity = resultUiConfig.entities[0]
    const home = entity.fields['HOME_SITEMAP'] as StringValue
    const sitemapName = home?.value ? home.value : 'WebMainArea'
    navigation(
      'DPR_CONFIGURATION/DPR_CONFIGURATION_FORM/00000000-0000-0000-0000-000000000000',
      sitemapName,
      undefined,
      new URLSearchParams({
        mode: 'Readonly',
      }),
    )
  }

  useEffect(() => {
    if (result === false) {
      const openModal = async () => {
        const dialogModalRef = dialogModal.createModal(<DataRetentionDialog />, onClose)
        dialogModalRef.open()
      }
      openModal().catch(console.error)
    }
  }, [result])
  return result
}
